import { getURLParameter } from '../utils';

/**
 * Check if element is in viewport
 *
 * @param element
 */
function elementInViewport(element) {
    let el = element;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
}

/**
 * Initialize Sticky Nav
 *
 */
function initStickyNav() {
    const steps = document.querySelectorAll('[data-step]');
    let currentStep = 0;

    // Add some extra padding to the Common Branding Footer
    const commonBrandingFooter = document.querySelector('.common-branding-banner--footer');
    commonBrandingFooter.classList.add('extra-padding');

    const stickyDotList = document.querySelector('.b-howto-hero-with-video__howto-sticky-nav .js-dots');
    // const heroDotList = document.querySelector('.b-howto-hero-with-video__howto-hero-nav .js-dots');
    const sectionList = document.querySelector('.js-sections');
    steps.forEach((step, index) => {
        if (step.dataset.step.length > '0') {
            // Populate the Dot List
            if ( stickyDotList ) {
                stickyDotList.innerHTML += `<li class="nav-item"><button class="nav-item__dot js-goto-step" data-goto="${index}"><span class="nav-item__flag">${step.dataset.step}</span></button></li>`;
            }
            // if ( heroDotList ) {
            //     heroDotList.innerHTML += `<li class="nav-item"><button class="nav-item__dot js-goto-step" data-goto="${index}"><span class="nav-item__flag">${step.dataset.step}</span></button></li>`;
            // }
            // Populate the Section List
            if ( sectionList ) {
                sectionList.innerHTML += `<li class="nav-item"><button class="nav-item__section js-goto-step" data-goto="${index}">${step.dataset.step}</button></li>`;
            }
        }
    });

    // Scroll to a specific section
    $('.js-goto-step').on('click', (e) => {
        e.preventDefault();

        const goto = parseInt(e.currentTarget.getAttribute('data-goto'), 10);

        steps.forEach((step, index) => {
            if (index === goto) {
                currentStep = index;
                steps[currentStep].scrollIntoView({behavior: 'smooth'});
            }
        });

        e.currentTarget.blur();
    });

    const navButtons = document.querySelectorAll('.nav-item__dot.js-goto-step');
    window.addEventListener('scroll', () => {
        steps.forEach((step, index) => {
            if (elementInViewport(step) && step.dataset.step.length > '0') {
                currentStep = index;

                navButtons.forEach((item) => {
                    item.classList.remove('active')
                });

                const navDotButtons = document.querySelectorAll(`.nav-item__dot[data-goto="${index}"]`);
                navDotButtons.forEach((navButton) => {
                    navButton.classList.add('active');
                });
            }
        });
    });

    const sectionNav = document.querySelector('.b-howto-hero-with-video__howto-section-nav');
    $('.js-section-menu').on('click', (e) => {
        e.preventDefault();

        sectionNav.classList.toggle('active');
    });

}


function initProTips() {
    const overlay = document.querySelector('.js-protip-overlay');

    $('.js-protip').hover( (e) => {
        $(e.currentTarget).addClass('hover');
    }, (e) => {
        $(e.currentTarget).removeClass('hover');
    });

    $('.js-protip-toggle').on('click', (e) => {
        e.preventDefault();

        $(e.currentTarget).parent().toggleClass('active');
        overlay.classList.toggle('is-active');

        $('.js-protip-close').blur();
    });
    $('.js-protip-close').on('click', (e) => {
        e.preventDefault();
        overlay.classList.remove('is-active');

        const activeProTip = document.querySelector('.js-protip.active');
        activeProTip.classList.remove('active');
        activeProTip.classList.remove('hover');

        $('.js-protip-close').blur();
    });

    overlay.addEventListener('click', () => {
        overlay.classList.remove('is-active');

        const activeProTip = document.querySelector('.js-protip.active');
        activeProTip.classList.remove('active');
        activeProTip.classList.remove('hover');
    });
}

/**
 * Notification for save article
 *
 * @param title
 * @param article
 */
function createConfirmationNotification(title, article) {
    const notificationWrapper = document.createElement('div');
    notificationWrapper.classList.add('notification-wrapper');
    notificationWrapper.innerHTML = `
    <div class="notification-container">
      <div class="notification-title-wrapper">
        <p class="notification-title">${title}</p>
        <button type="button" class="notification-close-button">
          <img class="e-icon" src="/wp-content/themes/electro/img/svg/x-dark.svg" alt="Close" width="10" height="10"/>
        </button>
      </div>
      <div class="notification-content-wrapper">
        <img class="notification-thumbnail" src="${article.thumbnail}?quality=50" alt=""></img>
        <p class="notification-description">${article.title}<p>
      </div>
    </div>
  `;
    document.body.appendChild(notificationWrapper);

    notificationWrapper.querySelector('.notification-close-button').addEventListener('click', () => {
        notificationWrapper.querySelector('.notification-container').classList.remove('is-active');

        setTimeout(() => {
            notificationWrapper.remove();
        }, 2000);
    });

    setTimeout(() => {
        notificationWrapper.querySelector('.notification-container').classList.add('is-active');
    }, 100);
}

function initializePage() {
    initStickyNav();
    initProTips();

    /**
     * copy to clipboard
     *
     * @param text to copy
     */
    function copyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        textArea.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(textArea.value);
        textArea.remove();
    }

    // handle copy to clipboard
    $('.js-copy-to-clipboard').on('click', (e) => {
        e.preventDefault();
        const text = document.URL;
        copyToClipboard(text);

        $('.js-share-recipe-menu').removeClass('is-active');
        $('.js-copied-wrapper').toggleClass('is-active');
        $('.js-share-recipe-button').focus();
        setTimeout(() => {
            $('.js-copied-wrapper').toggleClass('is-active');
        }, 2000);
    });

    // handle share recipe
    $('.js-share-recipe-button').on('click', (e) => {
        e.preventDefault();

        const menuEl = e.currentTarget.parentNode.querySelector('.js-share-recipe-menu');
        menuEl.classList.toggle('is-active');

        setTimeout(() => {
            menuEl.classList.remove('is-active');
        }, 2000);
    });

    // handle print
    $('.js-print-recipe').on('click', (e) => {
        e.preventDefault();
        console.warn('Printing recipe...');
        window.print();
    });

    // handle recipe save
    $('.js-save-recipe').on('click', (e) => {
        if (!CLWP_PC_GLOBAL.isLoggedIn) {
            console.warn('Need to be logged in');
            return false;
        }

        const currentTrigger = e.currentTarget;
        if (currentTrigger.dataset.saved === '1') {
            console.warn('Already saved');
            return false;
        }

        // rest call to save recipe
        fetch('/wp-json/electro/v1/user/save-page/', {
            method: 'POST',
            headers: {
                'X-WP-Nonce': Electro.wp_rest_nonce,
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pageId: currentTrigger.dataset.recipeId,
            }),
        })
            .then((result) => result.json())
            .then((res) => {
                const { status } = res;
                if (status === 0) {
                    currentTrigger.dataset.saved = '1';
                    createConfirmationNotification('This item has been saved to your profile under articles', {
                        thumbnail: currentTrigger.dataset.thumbnail,
                        title: currentTrigger.dataset.title,
                    });
                }
            });

        return false; // prevent default
    });

    // parameter to initiate save - used when user needs to login
    if (getURLParameter('do_action') === 'save-recipe') {
        $('.js-save-recipe').click();
    }
}

initializePage();
